module.exports = __webpack_public_path__ + "produce-fresh-grass-03.jpg?95dda0ba82718e10fb841ca984d0e927";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-03.jpg
// module id = 40
// module chunks = 0